import request from '@/utils/request'



export function getTodoCalendarMonth(params) {
  return request({
    url: '/admin/TodoCalendar/Month',
    method: 'get',
    params
  })
}

export function createTodoCalendar(data) {
  return request({
    url: '/admin/TodoCalendar/Create',
    method: 'post',
    data
  })
}

export function deleteTodoCalendar(id) {
  return request({
    url: `/admin/TodoCalendar/${id}`,
    method: 'delete'
  })
}

// export function getMessageTypeOptions() {
//   return request({
//     url: '/admin/Permission/MessageTypeOptions',
//     method: 'get'
//   })
// }

export function getUserMessageList(params) {
  return request({
    url: '/admin/UserMessage/List',
    method: 'get',
    params
  })
}

export function getUserMessageDetail(id) {
  return request({
    url: `/admin/UserMessage/Detail/${id}`,
    method: 'get'
  })
}

export function handleUserMessage(id,data) {
  return request({
    url: `/admin/UserMessage/Handle/${id}`,
    method: 'post',
    data:data
  })
}

export function getUserMessageUnhandledCount(params) {
  return request({
    url: '/admin/UserMessage/UnhandledCount',
    method: 'get',
    params
  })
}
export function getMessageTypeOptions(params) {
  return request({
    url: '/admin/TodoCalendar/MessageTypeOptions',
    method: 'get',
    params
  })
}
export function getStatisticsByMessageType(params) {
  return request({
    url: '/admin/TodoCalendar/StatisticsByMessageType',
    method: 'get',
    params
  })
}
